import './index.less';
import {RechargeSwiper} from "./snippets/newcomer-recharge";
import { gaPushDataLayer } from '@utils/index.js'
import { Scene } from "./sections/newcomer-scene/index";
import '../compare/components/index'
import { NewcomerHigherOutput } from "./snippets/newcomer-higher-output";
import { NewcomerFindPower } from "./snippets/newcomer-find-power";
import { NewcomerCalculator } from "./snippets/newcomer-calculator";
import { NewcomerSmartChoose } from "./snippets/newcomer-smart-choose";
$(document).ready(function(){
    new RechargeSwiper()
	new Scene({el: '.newcomer-scene'})
	new NewcomerHigherOutput({el: '.newcomer-higher-output'})
	new NewcomerFindPower({el: '.newcomer-find-power'})
	new NewcomerCalculator({el: '.newcomer-calculator'})
	new NewcomerSmartChoose({el: '.newcomer-smart-bottom'})
	$('.section-custom-newcomer-main .subnav-list .navli').each(function(){
		$(this).click(function() {
			 gaPushDataLayer('new_education_user_clicks', {
				module: 'Directory',
				position: $(this).text()
			});
		});
	})
	$('.section-custom-newcomer-main .jky-tabs-scroll-inner .jky-tabs-item').each(function(){
		$(this).click(function() {
			gaPushDataLayer('new_education_user_clicks', {
				module: 'Directory',
				position: $(this).text()
			});
		});
	})
})
